import {
  SAVE_USER_DETAILS,
  CLEAR_USER_DETAILS,
  SAVE_USER_ROLES,
} from "./Constants";
import {
  defaultObjForAddOrUpdateUser,
  DEFAULT_USER_SELECTION,
} from "../AddOrUpdateUser/Constants";

const INTIAL_STATE = {
  userDetails: defaultObjForAddOrUpdateUser,
  userRoles: [{ id: 0, role: DEFAULT_USER_SELECTION }],
};

export default function userListReducer(state = INTIAL_STATE, action) {
  switch (action.type) {
    case SAVE_USER_DETAILS:
      return { ...state, userDetails: action.userDetails };
    case CLEAR_USER_DETAILS:
      return { ...state, userDetails: defaultObjForAddOrUpdateUser };
    case SAVE_USER_ROLES:
      let userRoles = INTIAL_STATE.userRoles.concat(action.data);
      return { ...state, userRoles: userRoles };
    default:
      return state;
  }
}
